export default __webpack_public_path__ + "static/media/11.be798b64.png";